import { useState } from 'react';
import { Error } from '@progress/kendo-react-labels';
import { SubmitButton } from 'components';
import { DisputeEventTypes } from 'enums';
import { useDisputeService } from 'services';
import { useUserInfo } from 'state';
import styles from './AssignButton.module.scss';

type Props = {
    disputeId: string,
    onClick?: () => void
};

export default function AssignButton({ disputeId, onClick }: Props) {
    const { fullName, emailAddress } = useUserInfo();
    const service = useDisputeService();
    const [error, setError] = useState<string>();
    const [submitting, setSubmitting] = useState<boolean>(false);

    const handleClick = async () => {
        if (submitting || !disputeId) return;
        setSubmitting(true);
        setError(undefined);
        const result = await service?.routeDispute(disputeId, {
            eventTypeId: DisputeEventTypes.DisputeRoutedToUser,
            assigneeEmail: emailAddress,
            isPublic: false,
            note: `${fullName} assigned this dispute to themselves.`,
        });
        setSubmitting(false);
        if (result) {
            onClick && onClick();
        } else {
            setError('Error assigning');
        }
    };

    const button = (
        <SubmitButton
            className={styles.button}
            label="ASSIGN TO ME"
            submittingLabel="ASSIGNING"
            isSubmitting={submitting}
            fillMode="flat"
            themeColor="secondary"
            onClick={handleClick}
        />
    );

    return error ? (
        <div>
            {button}
            <Error>{error}</Error>
        </div>
    ) : button;
}